import React from "react";
import { Route, Switch } from "react-router-dom";
import Home from "./containers/Home";
import Login from "./containers/Login";
import NotFound from "./containers/NotFound";
import AppliedRoute from "./components/AppliedRoute";
import Signup from "./containers/Signup";
import SleepEntry from "./containers/SleepEntry";
import SleepEntries from "./containers/SleepEntries";
import Authenticated from "./components/AuthenticatedRoute";
import UnauthenticatedRoute from "./components/UnauthenticatedRoute";



export default ({ childProps }) =>
  <Switch>
    <AppliedRoute path={`${process.env.PUBLIC_URL}/home`} exact component={Home} props={childProps} />
    <AppliedRoute path={`${process.env.PUBLIC_URL}/`} exact component={Home} props={childProps} />
    <UnauthenticatedRoute path={`${process.env.PUBLIC_URL}/login`} exact component={Login} props={childProps} />
    <UnauthenticatedRoute path={`${process.env.PUBLIC_URL}/signup`} exact component={Signup} props={childProps} />
    <Authenticated path={`${process.env.PUBLIC_URL}/sleepEntry/new`} exact component={SleepEntry} props={childProps} />
    <Authenticated path={`${process.env.PUBLIC_URL}/sleepEntry/:id`} exact component={SleepEntries} props={childProps} />
    <Route component={NotFound} />
  </Switch>